module.exports = __webpack_public_path__ + "img/shiwuzhaoling.23b9a559.png";